{
  "portals": {
    "lp": "Celestial | Leader in Alternative Asset Management",
    "gp": "Celestial | Workbench",
    "lp-co-invest": "Celestial | LP Co-Investment Portal",
    "gp-co-invest": "Celestial | GP Co-Investment Portal",
    "subscription-templates": "Celestial | Subscriptions templates"
  }
}
